import Actions from '../Actions';

export const COLUMN_DEFS = [
  {
    field: 'label',
    headerName: 'NDC code',
    sortable: false,
    flex: 1
  },
  {
    field: 'title',
    headerName: 'Proprietary name',
    sortable: false,
    flex: 1
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellClass: 'no-border',
    cellRenderer: Actions,
    maxWidth: 100,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];

export const NDC_CODE_TYPES = [
  {
    value: 'brand_name',
    label: 'Proprietary name'
  },
  {
    value: 'application_number',
    label: 'Application number / monograph ID'
  },
  {
    value: 'generic_name',
    label: 'Non-proprietary name'
  },
  {
    value: 'package_ndc',
    label: 'NDC code'
  },
  {
    value: 'labeler_name',
    label: 'Labeler'
  }
];
